import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { store } from "../../../testStore";
import { TextInput } from "../../../lib/components/textInput";

import Loader from "react-loader-advanced";
import ReactLoading from "react-loading";

/* Result */
import Result from "iotera-base/result";

/* Json */
import {
  parse,
  parseArray,
  safeDeepGet,
  safeDeepGetWithType,
} from "iotera-base/json";
import { isEmpty } from "iotera-base/object";

/* Routes */
import { domainIsTenant as dit, S } from "../../../routes/routes";

/* Redux */
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

/* Sagas Actions */
import { buildWBoundActions } from "../../../redux/ducks";
import { actions as notificationActions } from "../../../redux/ducks/notification";

import { setDeviceFriendcomPayload } from "../../../testActions";
import { IoteraForm } from "../../../lib/components/form";
import { SubViewHeaderStep } from "../../../lib/components/subHeader";
import { Button } from "@material-ui/core";
import { setDeviceEmpty } from "../../../testActions";
import {
  setCallbackGlobal,
  unsetCallbackGlobal,
} from "../../../lib/components/callbackGlobal";

const SUBMIT_INDUSTRIAL_GATEWAY = "SUBMIT_INDUSTRIAL_GATEWAY";
const SUBMIT_COMPUTE_UNIT = "SUBMIT_COMPUTE_UNIT";
const SUBMIT_SENSOR_NODE = "SUBMIT_SENSOR_NODE";
const SUBMIT_ANDROID_STATION = "SUBMIT_ANDROID_STATION";
const WKEY = "DEVICE_ACTIVATION";
const wBoundActions = buildWBoundActions(WKEY);

const onError = (errors) =>
  console.log("Ada", errors.length, "error yang harus diperbaiki");

function schema() {
  return {
    type: "object",
    required: ["uid"],
    properties: {
      uid: { type: "string", minLength: 1 },
    },
  };
}

const uiSchema = {
  uid: {
    "ui:widget": (props) => {
      return (
        <TextInput
          id="uid"
          type="text"
          label="UID"
          placeholder="UID"
          textTooltip="Masukkan UID device ini"
          className="custom"
          value={props.value}
          onError={onError}
          required={props.required}
          onChange={(event) => props.onChange(event.target.value)}
        />
      );
    },
    "ui:options": {
      label: false,
    },
  },
};

function buildCheckConfig(self) {
  const _self = self;
  const _props = safeDeepGet(_self, ["props"]);
  const domainIsTenant = dit(_props);
  _props.wSetEnv({
    type: "body",
    env: "uid",
  });


  const wcallback = {
    started: function (id) {},
    finished: function (id, result) {
      if (result.code === Result.HTTP.OK) {
        let action = setDeviceEmpty();
        store.dispatch(action);
        _props.history.push(".." + S + ".." + S + "_device_list_");
        _props.showSingleNotification({ message: "Sukses" });
      } else {
        _props.showSingleNotification({ message: "Gagal" });
      }
      _self.setState({
        loading: false,
      });
    },
  }

  return {
    single_config: {
      [SUBMIT_INDUSTRIAL_GATEWAY]: {
        wparam: {
          ...domainIsTenant,
          method: "POST",
          path: "/service/web/device/io/industrial/add",
          timeout: 60000,
        },
        wcallback
      },
      [SUBMIT_COMPUTE_UNIT]: {
        wparam: {
          ...domainIsTenant,
          method: "POST",
          path: "/service/web/device/io/compute/add",
          timeout: 60000,
        },
        wcallback
      },
      [SUBMIT_SENSOR_NODE]: {
        wparam: {
          ...domainIsTenant,
          method: "POST",
          path: "/service/web/device/io/sensor/add",
          timeout: 60000,
        },
        wcallback
      },
      [SUBMIT_ANDROID_STATION]: {
        wparam: {
          ...domainIsTenant,
          method: "POST",
          path: "/service/web/device/io/android/add",
          timeout: 60000,
        },
        wcallback
      },
    },
  };
}

class Example extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: "1",
      loading: false,
      isDisabled: false,
    };
    this.toggle = this.toggle.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.canSubmit = this.canSubmit.bind(this);
  }

  componentDidMount() {
    // callback global
    setCallbackGlobal(this.props);
    this.props.wSetConfig(buildCheckConfig(this));
  }

  componentWillUnmount() {
    const _props = this.props;
    // callback global
    unsetCallbackGlobal(_props);
    _props.wUnsetConfig({ key: WKEY });
  }

  toggle(tab) {
    const _this = this;
    const _state = _this.state;
    if (_state.activeTab !== tab) {
      _this.setState({
        activeTab: tab,
      });
    }
  }

  myFunction() {
    let x = document.getElementById("myDIV");
    if (x.style.display === "none") {
      x.style.display = "block";
    } else {
      x.style.display = "none";
    }
    let y = document.getElementById("divMy");
    if (y.style.display === "none") {
      y.style.display = "block";
    } else {
      y.style.display = "none";
    }
  }

  handleSubmit(event) {
    const _this = this;
    const _props = _this.props;
    const _state = _this.state;
    const { isDisabled } = _state;
    let storeValue = store.getState();
    let dataToShow = storeValue;
    let dataToSubmit = event.formData;
    let uid = safeDeepGetWithType(event, ["formData", "uid"], "");
    if (uid === "") {
      _props.showSingleNotification({
        message: "Dev UID tidak boleh kosong",
        position: "tr",
        level: "error",
      });
      return;
    }
    dataToSubmit = {
      ...dataToShow.device,
      uid,
    };
    let action = setDeviceFriendcomPayload(dataToSubmit);
    _this.setState({
      formData: dataToSubmit,
    });
    store.dispatch(action);
    _this.setState({
      ..._state,
      dataToSubmit,
    });
    _props.wSetEnv({
      type: "body",
      env: "uid",
      value: { uid: event.formData["uid"] },
    });
    
    let id;
    if (dataToSubmit['type'] === 'IOTERA_COMPUTE_UNIT') {
      id = SUBMIT_COMPUTE_UNIT;
    } else if (dataToSubmit['type'] === 'IOTERA_SENSOR_NODE') {
      id = SUBMIT_SENSOR_NODE;
    } else if (dataToSubmit['type'] === 'IOTERA_ANDROID_STATION') {
      id = SUBMIT_ANDROID_STATION;
    } else {
      id = SUBMIT_INDUSTRIAL_GATEWAY;
    }

    if (isDisabled) {
    } else {
      _props.wSingleRequestCall({
        id,
        body: dataToSubmit,
      });
    }
  }

  canSubmit() {
    this.setState({
      isDisabled: false,
    });
  }

  goBack() {
    this.props.history.push(".." + S + "sensors");
  }

  render() {
    const _this = this;
    const _props = _this.props;
    const _state = _this.state;
    let storeValue = store.getState();
    let dataToShow = storeValue;
    if (isEmpty(dataToShow)) {
      _this.goBack();
    } else {
      if ("device" in dataToShow) {
        if (isEmpty(dataToShow.device)) {
          _this.goBack();
        } else {
          dataToShow = dataToShow.device;
        }
      } else {
        _this.goBack();
      }
    }
    const { isDisabled, loading } = _state;
    const spinner = (
      <div className="centeringItem">
        <ReactLoading type="bubbles" color="#ffffff" />
      </div>
    );
    return (
      <Loader show={loading} message={spinner}>
        <div className="view">
          <SubViewHeaderStep
            title="Tambah Perangkat"
            subTitle="Permohonan tambah perangkat Iotera baru"
            steps={["Kategori", "Informasi", "Aktivasi"]}
            activeStep={2}
          />
          <div className="io-container mt-12">
            <IoteraForm
              schema={schema()}
              uiSchema={uiSchema}
              onSubmit={_this.handleSubmit}
              formData={dataToShow}
            >
              <div className="button-right" style={{ marginTop: 10 }}>
                <Button
                  variant="outlined"
                  size="large"
                  style={{ minWidth: "0%" }}
                  onClick={_props.history.goBack}
                >
                  Kembali
                </Button>
                {isDisabled ? (
                  <Button
                    variant="outlined"
                    size="large"
                    color="primary"
                    type="submit"
                    style={{ marginLeft: 10, minWidth: "0%" }}
                  >
                    Aktivasi
                  </Button>
                ) : (
                  <Button
                    variant="contained"
                    size="large"
                    color="primary"
                    type="submit"
                    style={{ marginLeft: 10, minWidth: "0%" }}
                  >
                    Simpan
                  </Button>
                )}
              </div>
            </IoteraForm>
          </div>
        </div>
      </Loader>
    );
  }
}

const mapDispatchToProps = function (dispatch) {
  return {
    ...wBoundActions(dispatch),
    ...bindActionCreators(notificationActions, dispatch),
  };
};

export default connect(null, mapDispatchToProps)(withRouter(Example));
